import { useContext, useEffect, useState } from "react";
import "./HomePage.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Context } from "../context/Context";
import { VerifyPayment } from "../api/api";
import { useSearchParams } from "react-router-dom";
import PaymentCodes from "../constants/PaymentCodes";

const VerifyPaymentPage = () => {
  const { authUser } = useContext(Context);
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(false);
  const [retryable, setRetryable] = useState(false);
  const [credit, setCredit] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);

  const Authority = searchParams.get("Authority");
  const Status = searchParams.get("Status");

  const verifyPayment = () => {
    setLoading(true);
    setRetryable(false);

    VerifyPayment({ Authority, Status })
      .then(({ data }) => {
        const statusConfig = PaymentCodes.find(
          (p) => p.code == data.code
        );

        setPaymentStatus(
          statusConfig || {
            message: "پرداخت با موفقیت پردازش شد",
            message_type: "success",
          }
        );

        if (data.credit) {
          setCredit(data.credit);
        }
      })
      .catch((error) => {
        /**
         * Network error (no response)
         */
        if (!error.response) {
          setPaymentStatus({
            message:
              "ارتباط با سرور برقرار نشد. در صورت کسر وجه، می‌توانید دوباره تلاش کنید.",
            message_type: "warning",
          });
          setRetryable(true);
          return;
        }

        const { status, data } = error.response;

        switch (status) {
          case 500:
          case 503:
            setPaymentStatus({
              message:
                data?.message ||
                "خطا در اعتبار سنجی",
              message_type: "warning",
            });
            setRetryable(true);
            break;

          case 400:
            setPaymentStatus({
              message: data?.message || "پرداخت ناموفق بود",
              message_type: "error",
            });
            break;

          case 404:
            setPaymentStatus({
              message: data?.message || "پرداخت یافت نشد",
              message_type: "error",
            });
            break;

          case 422: {
            const firstError = Object.values(data)?.[0];
            setPaymentStatus({
              message: firstError || "اطلاعات ارسالی نامعتبر است",
              message_type: "error",
            });
            break;
          }

          default:
            setPaymentStatus({
              message: "خطا در اعتبار سنجی",
              message_type: "error",
            });
            setRetryable(true);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    verifyPayment();
  }, []);

  const getStatusIcon = () => {
    switch (paymentStatus?.message_type) {
      case "success":
        return "/assets/img/elements/success-icon.png";
      case "error":
        return "/assets/img/elements/error-icon.png";
      case "warning":
        return "/assets/img/elements/warning-icon.png";
      default:
        return "";
    }
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>اعتبارسنجی تراکنش</title>
      </Helmet>

      <div className="container-xxl">
        <div className="authentication-wrapper authentication-basic container-p-y">
          <div className="authentication-inner py-4">
            <div className="card">
              <div className="card-body p-3 text-center">

                {loading && (
                  <p className="mt-3">در حال بررسی وضعیت پرداخت...</p>
                )}

                {!loading && paymentStatus && (
                  <>
                    <img
                      src={getStatusIcon()}
                      width="100"
                      height="100"
                      className="mx-auto d-block mt-3"
                      alt="payment-status"
                    />

                    <h5 className="mt-3">
                      {paymentStatus.message}
                    </h5>

                    {credit && (
                      <p className="mt-2">
                        اعتبار فعلی:{" "}
                        <b className="text-success-app">
                          {credit}
                        </b>{" "}
                        تومان
                      </p>
                    )}

                    {retryable && (
                      <button
                        type="button"
                        className="btn btn-warning mt-3"
                        onClick={verifyPayment}
                        disabled={loading}
                      >
                        تلاش مجدد برای اعتبارسنجی
                      </button>
                    )}
                  </>
                )}

                {(authUser?.id && !retryable && !loading) && (
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-success-app mt-4"
                      onClick={() => (window.location.href = "/")}
                    >
                      برگشت به صفحه اصلی
                    </button>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </HelmetProvider>
  );
};

export default VerifyPaymentPage;
